export const SocialMediaLinks = {
	facebook: 'https://www.facebook.com/thegodfreymethodofficial/',
	tiktok: 'https://tiktok.com/@thegodfreymethod',
	instagram: 'https://www.instagram.com/thegodfreymethod/',
	youtube: 'https://www.youtube.com/channel/UC6gnV1UhFcRqEEwZ1LSi5Rw',
	helpAndSupport: 'https://thegodfreymethod.zendesk.com/hc/en-us'
};

export const SHOPIFY_PRODUCT_LINK = 'https://thegodfreymethod.myshopify.com/products';
